// extracted by mini-css-extract-plugin
export default {"pageLayout":"Inventories_pageLayout__f07wA","gridLayout":"Inventories_gridLayout__wUg+O","buttons":"Inventories_buttons__yh0dX","btn":"Inventories_btn__Bosh7"};